import { Component, OnInit } from '@angular/core';
import { CrmIntegrationService } from '../../../../core/services/crm-integration.service';
import { Router } from '@angular/router';
import { Title } from '@angular/platform-browser';

export const STRUCT_CAP_URL_ROOT = 'structured-capital';

export enum StructCapTabs {
  Active = 'Active',
  Person = 'Person',
  OnHold = 'On Hold',
  Followup = 'Followup',
  Dead = 'Dead',
  Closed = 'Closed',
  NonDeal = 'Non-Deal'
}

export const StructCapTabUrls = {
  'Active': `${STRUCT_CAP_URL_ROOT}/active`,
  'On Hold': `${STRUCT_CAP_URL_ROOT}/on-hold`,
  'Followup': `${STRUCT_CAP_URL_ROOT}/followup`,
  'Person': `${STRUCT_CAP_URL_ROOT}/person`,
  'Dead': `${STRUCT_CAP_URL_ROOT}/dead`,
  'Closed': `${STRUCT_CAP_URL_ROOT}/closed`,
  'Non-Deal': `${STRUCT_CAP_URL_ROOT}/non-deal`
};

@Component({
    selector: 'rms-struct-cap-crm-parent',
    templateUrl: './struct-cap-crm-parent.component.html',
    styleUrls: ['./struct-cap-crm-parent.component.scss'],
    standalone: false
})
export class StructCapCrmParentComponent implements OnInit {

  public tabs = StructCapTabs;

  constructor(
    private router: Router,
    private crmIntegration: CrmIntegrationService,
    private titleService: Title
  ) { }

  ngOnInit() {
    this.updateTab();
    this.titleService.setTitle('SC | Sonar | RMS');
  }

  private updateTab() {
    const tab = Object.entries(StructCapTabUrls).find((item) => `/sonar/${item[1]}` === this.router.url );
    if (tab) {
      this.crmIntegration.activeTab = tab[0] as StructCapTabs;
    } else {
      this.crmIntegration.activeTab = StructCapTabs.Active;
    }
  }

  get active() {
    return this.crmIntegration.activeTab;
  }

}
